import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import 'gw-portals-util-angular';
import DateUtil from 'gw-portals-util-js/DateUtil';
import LocalDateUtil from 'gw-portals-util-js/LocalDateUtil';

const fn = function (
    $translate, $q, $filter, lobConfig, $scope, $state, $stateParams, $window, ModalService, AccountService,
    SubmissionService, ProductService, UserService, OrganizationService, NewAccountService, defaultLocaleDetails,
    ViewModelService, UserInfoService, GPA_PC_ENTRY_POINT, CountrySpecificPSA
) {
    const lobMap = {
        'PSAUsedCarWarranty': 'puw', // PSA
        'PersonalAuto': 'pa',
        'Homeowners': 'ho',
        'HOPHomeowners': 'ho',
        'CommercialProperty': 'cp',
        'BusinessOwners': 'bop',
        'WC7WorkersComp': 'wc7',
    };
    const ctrl = Object.create(BaseCtrl);


    ctrl.init = () => {
        const applicationFeatures = ApplicationFeatures.getAllFeatures();
        $scope.accountTypes = applicationFeatures.accountTypes;
        $scope.gatewayQuote = applicationFeatures.gatewayquoteandbind === 'true';
        $scope.today = DateUtil.currentDateAtMidnight();
        $scope.hideFields = ['AddressLine2', 'AddressLine3']; // PSA
        $scope._availableProducts = [];
        $scope.isAgent = UserInfoService.isAgent();
        $scope.userDefaultCountry = UserInfoService.user.userDefaultCountry_PSA; // PSA
        $scope.CountrySpecificPSA = CountrySpecificPSA; // PSA
        $scope.EmailAttempt = 0;
        $scope.emailValidation = "";
        $scope.selectedOrganizationSubmissionVM = {
            aspects: {
                required: true,
                visible: true,
                get validationMessages() {
                    return [$filter('translate')('gateway.views.new-quote.errors.This is a required field')];
                },
                get valid() {
                    return $scope.selectedOrganizationSubmissionVM.value;
                }
            },
            value: ''
        };

        $scope.selectedOrganizationAccountVM = {
            aspects: {
                required: true,
                visible: true,
                get validationMessages() {
                    return [$filter('translate')('gateway.views.new-quote.errors.This is a required field')];
                },
                get valid() {
                    return $scope.selectedOrganizationAccountVM.value;
                }
            },
            value: ''
        };

        $scope.producerCodes = [];

        $scope.newAccount = {
            accountHolder: {},
        };
        $scope.accountHolder = {
            contactName: '',
            primaryAddress: {
                city: '',
                //state: '',
                postalCode: ''
            },
            contactsInfoData: []
        };
        $scope.lists =[
            { 'vl': "mail", checked: false },
            { 'vl': "phone", checked: false },
            { 'vl': "sms", checked: false  },
            { 'vl': "bypost", checked: false  },
        ]
        $scope.change = function(selected,value){
            if(value.selected){
                $scope.accountHolder.contactsInfoData.push(value.vl);
            }else{
                 $scope.accountHolder.contactsInfoData.splice($scope.accountHolder.contactsInfoData.indexOf(value.vl), 1);
            }
        };
        const TRANSLATION_KEYS = {
            mail: 'psa.gateway.puw.views.new-quote-account-contact.Email',
            phone: 'psa.gateway.puw.views.new-quote-account-contact.Phone',
            sms: 'psa.gateway.puw.views.new-quote-account-contact.sms',
            bypost: 'psa.gateway.puw.views.new-quote-account-contact.post'
        };

         /**
             * Get the translation for the contactInfo(added as part of client consent)
             * @param {String} contactKey
             * @returns {String}
             */
          $scope.getContactInfoTranslation = (contactKey) => {
            const translationKey = TRANSLATION_KEYS[contactKey];
            let returnString = '';
            if (translationKey) {
                returnString = $translate.instant(translationKey);
            }
            return returnString;
        };
        $scope.availableProducts = () => {
            return $scope._availableProducts;
        };

        $scope.newSubmission = {
            effectiveDate: LocalDateUtil.today(),
            dateQuoteNeeded_PSA: LocalDateUtil.today(),
            producerCode: null, // fix for angular 1.6.5 commit 17d34b7 default option do not work if empty string rather than null
            //state: null,
            productCode: '',
            virtualProductCode_PSA: '',
            linkEntrySub: false
        };
        $scope.newSubmission.country = $scope.defaultCountryCode || defaultLocaleDetails.countryCode;

        $scope.setVirtualCodePSA = () => {
            if (_.isEmpty($scope.selectedProductPSA.value)) {
                console.log(scope.selectedProductPSA.value);
                $scope.newSubmissionView.productCode.value = null;
                $scope.newSubmissionView.virtualProductCode_PSA.value = null;
            } else {
                $scope.newSubmissionView.productCode.value = JSON.parse($scope.selectedProductPSA.value).productCode;
                $scope.newSubmissionView.virtualProductCode_PSA.value = JSON.parse($scope.selectedProductPSA.value).virtualProductCode_PSA;
            }
        };

        $scope.newSubmissionView = ViewModelService.create($scope.newSubmission, 'pc', 'edge.capabilities.gateway.job.submission.dto.NewSubmissionDTO');

        $scope.selectedProductPSA = {
            value: null
        };

        $scope.refreshingProducts = false;
        $scope.refreshingProducerCodes = false;


        if ($stateParams.accountNumber && $stateParams.accountNumber.length > 0) {
            $scope.accountNumber = $stateParams.accountNumber;
            ctrl.findAccount($scope.accountNumber);
        } else {
            $scope.isAnExistingAccount = false;

            // Subtype of entity in PolicyCenter is capitalised
            const criteriaContactType = NewAccountService.AccountSearchCriteria.contactType;
            $scope.contactType = criteriaContactType ? criteriaContactType.charAt(0).toUpperCase() + criteriaContactType.slice(1) : 'Person'; // PSA

            if ($scope.contactType === 'Person') {
                $scope.accountHolder.prefix = NewAccountService.AccountSearchCriteria.prefix;
                $scope.accountHolder.firstName = NewAccountService.AccountSearchCriteria.firstName;
                $scope.accountHolder.lastName = NewAccountService.AccountSearchCriteria.lastName;
                if (NewAccountService.AccountSearchCriteria.lastNameKanji) {
                    $scope.accountHolder.firstNameKanji = NewAccountService.AccountSearchCriteria.firstNameKanji;
                    $scope.accountHolder.lastNameKanji = NewAccountService.AccountSearchCriteria.lastNameKanji;
                }
            } else {
                $scope.accountHolder.contactName = NewAccountService.AccountSearchCriteria.contactName;
                if (NewAccountService.AccountSearchCriteria.contactNameKanji) {
                    $scope.accountHolder.contactNameKanji = NewAccountService.AccountSearchCriteria.contactNameKanji;
                }
            }

            $scope.accountHolder.primaryAddress.city = NewAccountService.AccountSearchCriteria.city;
            // PSA $scope.accountHolder.primaryAddress.state = NewAccountService.AccountSearchCriteria.state;
            $scope.accountHolder.primaryAddress.postalCode = NewAccountService.AccountSearchCriteria.postalCode;
            $scope.accountHolder.primaryAddress.country = NewAccountService.AccountSearchCriteria.country || $scope.userDefaultCountry; // PSA
            if (NewAccountService.AccountSearchCriteria.cityKanji) {
                $scope.accountHolder.primaryAddress.cityKanji = NewAccountService.AccountSearchCriteria.cityKanji;
            }
            $scope.accountHolder.primaryAddress.addressLine1 = NewAccountService.AccountSearchCriteria.addressLine1;
            $scope.accountHolder.workNumber = NewAccountService.AccountSearchCriteria.workNumber;
            $scope.accountHolder.cellNumber = NewAccountService.AccountSearchCriteria.cellNumber;
            $scope.accountHolder.emailAddress1 = NewAccountService.AccountSearchCriteria.emailAddress1;
            $scope.accountHolder.fiscalCode_PSA = NewAccountService.AccountSearchCriteria.fiscalCode;
            $scope.accountHolder.url =  NewAccountService.AccountSearchCriteria.url;
            $scope.accountHolderView = setAccountHolderView($scope.accountHolder);

            ctrl.refreshOrgTypes_PSA();

            NewAccountService.AccountSearchCriteria.contactName = '';
            NewAccountService.AccountSearchCriteria.lastName = '';
            NewAccountService.AccountSearchCriteria.prefix = '';
            NewAccountService.AccountSearchCriteria.firstName = '';
            NewAccountService.AccountSearchCriteria.city = '';
            // PSA NewAccountService.AccountSearchCriteria.state = '';
            NewAccountService.AccountSearchCriteria.postalCode = '';
        }

        if ($scope.isAgent) {
            getProducerCodes();
        } else {
            const getOrganizationsPromise = OrganizationService.getAvailableOrganizations();

            $scope.allOrganizationsLookup = {
                getMatches: function (userinput) {
                    return getOrganizationsPromise
                        .then(allOrganizations => _(allOrganizations)
                            .filter(organization => this.toString(organization).toLowerCase()
                                .includes((userinput || '').toLowerCase()))
                            .take(10)
                            .valueOf()).catch(() => ModalService.showError('gateway.views.new-quote.Error retrieving organizations', 'gateway.views.new-quote.Please check for errors and try again'));
                },
                toString: organization => organization.displayName
            };

            $scope.$watch('selectedOrganizationAccountVM.value', organization => {
                if (!organization && $scope.accountHolderView) {
                    $scope.accountHolderView.producerCode = '';
                }
                ctrl.refreshProducerCodes(organization);
            });

            $scope.$watch('selectedOrganizationSubmissionVM.value', organization => {
                if (!organization) {
                    $scope.newSubmissionView.producerCode = '';
                    $scope.newSubmissionView.productCode = '';
                }
                ctrl.refreshProducerCodes(organization);
            });
        }

    };

    function setAccountHolderView(account) {
        const viewModel = ViewModelService.create(account, 'pc', 'edge.capabilities.policycommon.accountcontact.dto.AccountContactDTO', {
            'ProducerCodeRequired': true
        });
        console.log("line 209",viewModel)
        viewModel.isAgentPortalContact = true;
        if ($scope.contactType === 'Person') {
            viewModel.subtype.value = 'Person';
        } else {
            viewModel.subtype.value = 'Company';
        }
        return viewModel;
    }

    ctrl.refreshProducerCodes = (organization) => {
        if (!organization ||
            // PSA $scope.newSubmission.state === undefined ||
            $scope.newSubmission.effectiveDate === null ||
            $scope.newSubmission.effectiveDate === '' ||
            $scope.newSubmission.dateQuoteNeeded_PSA === null ||
            $scope.newSubmission.dateQuoteNeeded_PSA === '') {
            $scope.submissionFormNotValid = true;
            return;
        }

        $scope.refreshingProducerCodes = true;
        $scope.submissionFormNotValid = false;

        getProducerCodesForAnOrganization(organization);
    };

    function getProducerCodesForAnOrganization(organization) {
        const producerCodesPromise = OrganizationService.getProducerCodeForOrganization(organization);
        producerCodesPromise.then((producerCodesResponse) => {
            $scope.producerCodes = producerCodesResponse;
            $scope.refreshingProducerCodes = false;
        }, () => {
            ModalService.showError('gateway.views.modal.Error', 'gateway.views.modal.Error.Data');
        });
    }

    function getProducerCodes() {
        const producerCodesPromise = UserService.getAvailableProducerCodesForCurrentUser();
        producerCodesPromise.then((producerCodesResponse) => {
            $scope.producerCodes = producerCodesResponse;
            // PSA: pre-select producer code, when just 1 is available
            if ($scope.producerCodes.length === 1) {
                $scope.newSubmissionView.producerCode.value = $scope.producerCodes[0].code;
                if ($scope.accountHolderView !== undefined) {
                    $scope.accountHolderView.producerCode.value = $scope.producerCodes[0].code;
                }
            }
        });
    }

    function getAvailableProducts() {
        AccountService.getAvailableProductsForAccount(copyOfNewSubmission())
            .then((availableProductsResponse) => {
                $scope._availableProducts = availableProductsResponse;
                $scope.newSubmission.productCode = '';
                // PSA: pre-select product, when just 1 is available
                if ($scope._availableProducts.length === 1) {
                    $scope.selectedProductPSA.value = JSON.stringify($scope._availableProducts[0]);
                    $scope.setVirtualCodePSA();
                }
                $scope.refreshingProducts = false;
            }, () => {
                $scope.refreshingProducts = false; // PSA
                ModalService.showError('gateway.views.modal.Error', 'gateway.views.modal.Error.Data');
            });
    }

    function copyOfNewSubmission() {
        const copyOfSubmission = angular.copy($scope.newSubmission);
        return copyOfSubmission;
    }

    ctrl.setCancelState = () => {
        const title = 'gateway.controllers.NewQuoteCtrl.Cancel Quote';
        const msg = 'gateway.controllers.NewQuoteCtrl.Are you sure you want to cancel the new quote?';
        const description = null;

        const cancelDialogPromise = ModalService.showWarning(title, msg, description, $filter('translate')('gateway.views.modal.Yes'), 'gw-btn-primary', $filter('translate')('gateway.views.modal.No')).result;
        cancelDialogPromise.then(() => {
            const accountNumber = $scope.accountNumber ? $scope.accountNumber : $scope.newAccount.accountNumber;
            if (accountNumber) {
                $state.go('accounts.detail.summary', {
                    accountNumber
                });
            } else if ($scope.isAgent) {
                $state.go('accounts.index');
            } else {
                $state.go('gatewayLanding');
            }
        });
    };


    ctrl.submitCreateAccountForm = function (newAccountForm) {
        newAccountForm.submitted = true;

        if ($scope.contactType === 'Person') {
            $scope.accountHolder.contactName = `${$scope.accountHolder.firstName} ${$scope.accountHolder.lastName}`;
        }
        if (newAccountForm.invalid) {
            return;
        }

        if(($scope.accountHolderView.emailAddress1.value == undefined && $scope.EmailAttempt == 0) ){
            $scope.emailValidation = $translate.instant('gateway.views.new-quote-account-search.ContactType.EmailValidation');
            $scope.EmailAttempt = 1;
            return ;
        }
        this.createNewAccount();
    };

    ctrl.submitNewSubmissionForm = function (newSubmissionForm) {
        newSubmissionForm.submitted = true;
        if (newSubmissionForm.invalid) {
            return;
        }

        this.startSubmission();
    };

    ctrl.saveNewSubmission = function (newSubmissionForm) {
        newSubmissionForm.submitted = true;
        if (newSubmissionForm.invalid) {
            return;
        }

        this.startSubmission(true);
    };

    ctrl.defineWatches = () => {
         //UCWAR-812
         $scope.$watch('newSubmission.producerCode', () => {
             ctrl.refreshProducts();
         });
        // $scope.$watch('newSubmission.state', () => {
        //     ctrl.refreshProducts();
        // });

        $scope.$watch('newSubmission.effectiveDate', () => {
            ctrl.refreshProducts();
        });

        $scope.$watch('newSubmission.accountNumber', (newVal) => {
            if (newVal) {
                ctrl.refreshProducts();
            }
        });

        $scope.$watch('accountHolder.primaryAddress.country', () => {
            ctrl.refreshOrgTypes_PSA();
        });
    };

    ctrl.refreshOrgTypes_PSA = () => {
        if ($scope.contactType === 'Company') {
            $scope.organizationTypes_PSA = $scope.CountrySpecificPSA.orgTypesFor($scope.accountHolder.primaryAddress.country);
            if ($scope.accountHolder.organizationType_PSA && !$scope.organizationTypes_PSA.find((item) => item.code === $scope.accountHolder.organizationType_PSA)) {
                // reset organizationType_PSA if it is not amongst available values
                $scope.accountHolder.organizationType_PSA = null;
            }
        }
    };

    ctrl.refreshProducts = () => {
        const isEmpty = value => !value;

        if (//isEmpty($scope.newSubmission.producerCode) ||
            // PSA isEmpty($scope.newSubmission.state) ||
            isEmpty($scope.newSubmission.effectiveDate) ||
            isEmpty($scope.newSubmission.dateQuoteNeeded_PSA)) {
            $scope.submissionFormNotValid = true;
            return;
        }

        $scope.refreshingProducts = true;
        $scope.submissionFormNotValid = false;

        getAvailableProducts();
    };

    ctrl.findAccount = (accountNumber) => {
        if (angular.isDefined(accountNumber) && accountNumber.length > 0) {
            const findAccountPromise = AccountService.getAccountDetails(accountNumber);
            $scope.findAccountPromise = findAccountPromise;

            $q.when(findAccountPromise, (account) => {
                if (account.accountHolder) {
                    $scope.contactType = account.accountHolder.subtype;
                    $scope.newAccount = account;
                    // PSA $scope.newSubmission.state = account.accountHolder.primaryAddress.state;
                    $scope.displayAddressArray = account.accountHolder.primaryAddress.displayName.split(', ');
                    if (account.accountHolder.primaryAddress.province != undefined) {
                        $scope.displayAddressArray.splice(2, 0, account.accountHolder.primaryAddress.province);
                    }
                    $scope.newSubmission.accountNumber = account.accountNumber;
                    $scope.isAnExistingAccount = true;
                    // 608 starts
                    $scope.lists.forEach(function (list) {
                        account.accountHolder.contactsInfoData.forEach(function (i) {
                            if (list.vl === i) {
                                list.checked = true;
                            }
                        });
                    })  
                }else {
                    ModalService.showError('gateway.views.modal.Error', 'gateway.views.new-quote.error.findAccount.account.type');
                    window.history.back();
                }

                $scope.accountHolderView = setAccountHolderView($scope.newAccount);
            }, () => {
                const msg = $translate('gateway.views.new-quote.error.findAccount.noaccount', {
                    accountNumber
                });
                ModalService.showError('gateway.views.modal.Error', msg);
                $state.go('newQuoteSearch');
            });
        }
    };

    ctrl.changeContactType = (type) => {
        $scope.contactType = type;
        $scope.accountHolderView = setAccountHolderView($scope.accountHolder);
    };

    ctrl.createNewAccount = () => {
        const newAccount = {};

        if ($scope.contactType === 'Person') {
            $scope.accountHolder.primaryAddress.addressType = 'home';
            newAccount.accountHolder = $scope.accountHolder;
        } else {
            $scope.accountHolder.primaryAddress.addressType = 'business';
            newAccount.accountHolder = $scope.accountHolder;
        }
        newAccount.producerCodes = [{
            code: $scope.accountHolder.producerCode
        }];

        const newAccountPromise = AccountService.getOrCreateAccount(newAccount);
        $scope.newAccountPromise = newAccountPromise;

        $q.when(newAccountPromise, (newAccountResponse) => {
            if (newAccountResponse.accountNumber > 0) {
                $scope.newAccount = newAccountResponse;
                // PSA $scope.newSubmission.state = newAccountResponse.accountHolder.primaryAddress.State;
                $scope.displayAddressArray = newAccountResponse.accountHolder.primaryAddress.displayName.split(', ');
                if (newAccountResponse.accountHolder.primaryAddress.province != undefined) {
                    $scope.displayAddressArray.splice(2, 0, newAccountResponse.accountHolder.primaryAddress.province);
                }
                $scope.newSubmission.accountNumber = newAccountResponse.accountNumber;
                $scope.isAnExistingAccount = true;
            }
        }, () => {
            ModalService.showError('gateway.views.modal.Error', 'gateway.views.new-quote.error.create.account');
        });
        // UCWAR-766
        $scope.newSubmissionView.producerCode.value = $scope.accountHolder.producerCode;
        // 608 starts
        $scope.lists.forEach(function (list){
        	newAccount.accountHolder.contactsInfoData.forEach(function(i){
              if(list.vl === i) {
              	list.checked = true;
              }
            });
        })
        // 608 ends
    };

    ctrl.startSubmission = (saving) => {
        if ($scope.isAnExistingAccount) {
            doSubmission();
        }

        function doSubmission() {
            const newSubmission = copyOfNewSubmission();
            newSubmission.accountNumber = $scope.newAccount.accountNumber;
            newSubmission.linkEntrySub = $scope.accountHolder.url != null ? true : false;

            const newSubmissionPromise = SubmissionService.createSubmission(newSubmission);
            $scope.newSubmissionPromise = newSubmissionPromise;

            $q.when(newSubmissionPromise, (newSubmissionResponse) => {
                if (newSubmissionResponse.jobNumber > 0) {
                    if ($scope.gatewayQuote && _.includes(lobConfig.lobs, lobMap[$scope.newSubmission.productCode])) {
                        if (saving) {
                            $state.go('quote.detail.summary', {
                                submissionNumber: newSubmissionResponse.jobNumber
                            });
                        }
                        else {
                            $state.transitionTo('quoteentry', {
                                postalCode: $scope.newAccount.accountHolder.primaryAddress.postalCode,
                                quoteID: newSubmissionResponse.jobNumber,
                                gatewayportalnewsubmission: true
                            });
                        }
                    } else {
                        // Redirect to PolicyCenter EntryPoint to continue new submission
                        $window.location.href = `${GPA_PC_ENTRY_POINT}?JobNumber=${newSubmissionResponse.jobNumber}`;
                    }
                }
            }, () => {
                ModalService.showError('gateway.views.modal.Error', 'gateway.views.new-quote.error.create.submission');
            });
        }
    };

    return ctrl.create($scope);
};

fn.$inject = ['$translate', '$q', '$filter', 'lobConfig', '$scope', '$state', '$stateParams', '$window', 'ModalService', 'AccountService',
    'SubmissionService', 'ProductService', 'UserService', 'OrganizationService', 'NewAccountService', 'defaultLocaleDetails',
    'ViewModelService', 'UserInfoService', 'GPA_PC_ENTRY_POINT', 'CountrySpecificPSA'];

export default fn;
